export default __webpack_public_path__ + "static/media/arrow1.23a4c6cf.svg";